import React from 'react';
import { I18n } from '@aws-amplify/core';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';

export function PriorityFormItem(): JSX.Element {
	const options = [
		{ label: I18n.get('Low'), value: 1 },
		{ label: I18n.get('Medium'), value: 2 },
		{ label: I18n.get('High'), value: 3 }
	];

	return (
		<FormItem label="Priority" name="priority" required>
			<Select placeholder="Priority" options={options} />
		</FormItem>
	);
}
